import { ContainerModule } from 'inversify';
import type { UploadDispatcher, MultipartUploadStrategy } from '@dealroadshow/file-uploader';
import type { ISocketProcessingAdapter, IUploadDispatcherFactory, IUploadAdapter } from './interfaces';
import DITypes from './types';
import UploadAdapter from '../UploadAdapter';
import UploadDispatcherFactory from '../UploadDispatcherFactory';
import { AllocateSocketProcessingAdapter } from '../SocketProcessingAdapter';

export const FileUploadModule = new ContainerModule(({ bind }) => {
  bind<IUploadAdapter>(DITypes.UploadAdapter)
    .to(UploadAdapter)
    .inSingletonScope();

  bind<ISocketProcessingAdapter>(DITypes.SocketProcessingAdapter)
    .to(AllocateSocketProcessingAdapter)
    .inSingletonScope();

  bind<IUploadDispatcherFactory>(DITypes.UploadDispatcherFactory)
    .to(UploadDispatcherFactory)
    .inSingletonScope();

  bind<UploadDispatcher<MultipartUploadStrategy>>(DITypes.UploadDispatcher)
    .toDynamicValue(({ get }) => {
      return get<IUploadDispatcherFactory>(DITypes.UploadDispatcherFactory)
        .create();
    })
    .inSingletonScope();
});
